import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const RelatedServices = [
  { title: 'Title Insurance', path: '/services/title-insurance' },
  { title: 'Title Searches', path: '/services/title-searches' },
  { title: 'Refinancing Services', path: '/services/refinancing' },
  { title: 'Deed Preparation', path: '/services/deed-preparation' },
];

const ResidentialSettlementsPage = () => {
  return (
    <>
      <head>
        <title>Residential Settlements Bucks County PA | Black Dog Settlement</title>
        <meta name="description" content="Expert residential settlement services for home buyers and sellers in Bucks, Montgomery, Chester, and Delaware County, PA. Black Dog Settlement ensures smooth, on-time closings. Call 215-499-0796." />
        <meta name="keywords" content="residential settlement Bucks County PA, home closing Newtown PA, real estate settlement Montgomery County, home buyer closing Chester County Pennsylvania" />
        <link rel="canonical" href="https://www.blackdogsettlement.com/services/residential-settlements" />
        <meta name="geo.region" content="US-PA" />
        <meta name="geo.placename" content="Newtown, Pennsylvania" />
        <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700;800;900&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
      </head>
      <div style={{ fontFamily: "'Inter', sans-serif" }}>
        <Navbar />

        {/* Hero */}
        <section className="bg-[#0f0f0f] pt-36 pb-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="flex items-center gap-2 text-stone-500 text-xs mb-8">
              <Link to="/" className="hover:text-[#c9a84c] cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <Link to="/services" className="hover:text-[#c9a84c] cursor-pointer">Services</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white/40">Residential Settlements</span>
            </div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-[#c9a84c]"></div>
              <span className="text-[#c9a84c] text-xs font-bold tracking-[0.3em] uppercase">Service</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-black text-white leading-tight mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Residential<br /><span className="text-[#c9a84c]">Settlements</span>
            </h1>
            <p className="text-white/40 text-base leading-relaxed max-w-xl">
              Smooth, stress-free closings for home buyers and sellers throughout Bucks, Montgomery, Chester, and Delaware County, PA.
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col lg:flex-row gap-16">
            {/* Main content */}
            <div className="w-full lg:w-[65%]">
              <div className="mb-10 rounded-none overflow-hidden h-[380px]">
                <img
                  src="https://storage.readdy-site.link/project_files/24cbc93a-97c5-4a4c-8795-e638165a0b41/f8ffaf53-66d3-47e6-a811-00f90e880bd7_shutterstock_2222205287.jpg?v=ad7c6393315be09539bb9c7f89b194b7"
                  alt="Residential settlement closing in Bucks County Pennsylvania"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <h2 className="text-3xl font-black text-[#0f0f0f] mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Your Trusted Partner for Home Closings in Southeastern PA
              </h2>
              <div className="space-y-4 text-stone-500 text-sm leading-relaxed mb-10">
                <p>
                  Buying or selling a home is one of the most significant financial decisions of your life. At Black Dog Settlement, we make the closing process as smooth and stress-free as possible for buyers, sellers, and real estate agents throughout Bucks, Montgomery, Chester, and Delaware County, Pennsylvania.
                </p>
                <p>
                  Our experienced settlement professionals coordinate every detail — from reviewing the title search and preparing closing documents to working with your lender and real estate agent — so that closing day goes exactly as planned.
                </p>
                <p>
                  We pride ourselves on clear communication throughout the entire process. You'll always know what to expect, what documents you'll need to sign, and exactly how much money will change hands at closing. No surprises.
                </p>
              </div>

              <h3 className="text-xl font-black text-[#0f0f0f] mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>What's Included</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
                {[
                  'Purchase & sale closings',
                  'Coordination with lenders & agents',
                  'HUD-1 / Closing Disclosure review',
                  'Same-day recording available',
                  'Evening & weekend closings by appointment',
                  'Title search & insurance coordination',
                  'Deed preparation & recording',
                  'Payoff & lien resolution',
                  'Buyer & seller representation',
                  'Post-closing document delivery',
                ].map((item) => (
                  <div key={item} className="flex items-center gap-3 text-sm text-stone-600 border border-stone-100 px-4 py-3">
                    <div className="w-4 h-4 flex items-center justify-center shrink-0">
                      <i className="ri-check-line text-[#c9a84c]"></i>
                    </div>
                    {item}
                  </div>
                ))}
              </div>

              <h3 className="text-xl font-black text-[#0f0f0f] mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Counties We Serve</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
                {['Bucks County', 'Montgomery County', 'Chester County', 'Delaware County'].map((c) => (
                  <div key={c} className="bg-[#f7f5f0] p-4 text-center">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                      <i className="ri-map-pin-2-fill text-[#c9a84c]"></i>
                    </div>
                    <p className="text-xs font-bold text-[#0f0f0f]">{c}</p>
                    <p className="text-xs text-stone-400">PA</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Sidebar */}
            <div className="w-full lg:w-[35%] space-y-6">
              {/* CTA card */}
              <div className="bg-[#0f0f0f] p-8">
                <h3 className="text-white text-xl font-black mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Ready to Schedule?</h3>
                <p className="text-white/40 text-sm mb-6">Contact us today to schedule your residential settlement in Bucks, Montgomery, Chester, or Delaware County.</p>
                <a
                  href="tel:2154990796"
                  className="flex items-center justify-center gap-2 w-full bg-[#c9a84c] hover:bg-[#b8963e] text-[#0f0f0f] font-bold py-3.5 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-colors mb-3"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line"></i>
                  </div>
                  Call 215-499-0796
                </a>
                <Link
                  to="/contact"
                  className="flex items-center justify-center w-full border border-white/20 hover:border-white/50 text-white font-bold py-3.5 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-colors"
                >
                  Send a Message
                </Link>
              </div>

              {/* Related services */}
              <div className="border border-stone-100 p-6">
                <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-stone-400 mb-4">Related Services</h4>
                <div className="space-y-2">
                  {RelatedServices.map((s) => (
                    <Link
                      key={s.path}
                      to={s.path}
                      className="flex items-center justify-between py-2.5 border-b border-stone-100 last:border-0 text-sm text-[#0f0f0f] hover:text-[#c9a84c] transition-colors cursor-pointer group"
                    >
                      {s.title}
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line text-xs text-stone-300 group-hover:text-[#c9a84c] transition-colors"></i>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Contact info */}
              <div className="bg-[#f7f5f0] p-6 space-y-3">
                <p className="text-xs font-bold tracking-[0.2em] uppercase text-stone-400 mb-4">Contact Info</p>
                <div className="flex items-center gap-3 text-sm text-stone-500">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-2-line text-[#c9a84c]"></i>
                  </div>
                  842 Durham Rd, Newtown, PA 18940
                </div>
                <div className="flex items-center gap-3 text-sm text-stone-500">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-time-line text-[#c9a84c]"></i>
                  </div>
                  Mon–Fri: 9AM–5PM
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default ResidentialSettlementsPage;
